import { Link } from 'react-router-dom';
import { Icon } from '@sakhtar/design-system/react';
import { faInt } from '../format.js';
import { isOutOfTokens } from '../preflight.js';

export interface OutOfTokensBarProps {
  /** Integer tokens left (sample wallet). */
  readonly balance: number;
  /** Integer estimate of the refused question; omitted for the composer's standing notice. */
  readonly estimate?: number | undefined;
  /** REAL `tenant.subscription.manage`: without it no purchase control is rendered at all (frame I-2). */
  readonly canPurchase: boolean;
  /** `${base}/ai/wallet` - the wallet tab owns the purchase flow. */
  readonly walletHref: string;
}

/**
 * Frames I / I-2 - the warning bar shared by the composer's standing notice
 * (nothing can be sent) and the in-stream message (this question is too
 * expensive for the balance). With the purchase permission it links to the
 * wallet's purchase flow; without it, it tells the user to ask a tenant admin
 * and renders NO button (not even a disabled one - the design says so).
 */
export function OutOfTokensBar({
  balance,
  estimate,
  canPurchase,
  walletHref,
}: OutOfTokensBarProps) {
  const empty = isOutOfTokens(balance);
  return (
    <div className="ai-warnbar" role="status">
      <span className="ai-warnbar__icon" aria-hidden="true">
        <Icon name="shield" size="md" />
      </span>
      <div className="ai-warnbar__body">
        <span>
          {empty ? (
            'موجودی توکن تمام شده است.'
          ) : (
            <>
              موجودی توکن برای این پرسش کافی نیست (برآورد:{' '}
              <span className="sk-num">{faInt(estimate ?? 0)}</span> توکن، موجودی:{' '}
              <span className="sk-num">{faInt(balance)}</span> توکن).
            </>
          )}{' '}
          {canPurchase
            ? 'سابقهٔ گفتگوها خواندنی می‌ماند و چیزی حذف نمی‌شود.'
            : 'برای شارژ به مدیر سیستم اطلاع دهید.'}
        </span>
        {estimate !== undefined ? (
          <span className="ai-warnbar__hint">پرسش ارسال نشد و توکنی کسر نشد.</span>
        ) : null}
      </div>
      {canPurchase ? (
        <Link to={walletHref} className="sk-btn sk-btn--primary sk-btn--sm">
          خرید توکن
        </Link>
      ) : null}
    </div>
  );
}
